import React, { useRef } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import './Signature.css';

const Signature = ({ onChangeResult, signedName1 = "Yang Menyerahkan", signedName2 = "Yang Menerima" }) => {
  const signaturePad1 = useRef(null);
  const signaturePad2 = useRef(null);

  const saveSignature = () => {
    const x = signaturePad1.current.getTrimmedCanvas().toDataURL('image/png');
    const y = signaturePad2.current.getTrimmedCanvas().toDataURL('image/png');

    onChangeResult({x, y});
  };

  const clearSignature1 = () => {
    signaturePad1.current.clear();
  };

  const clearSignature2 = () => {
    signaturePad2.current.clear();
  };

  return (
    <div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Signature Section 1 */}
        <div className="signature-section bg-gray-100 p-4 rounded shadow">
          <h3 className="text-lg font-semibold mb-4 text-center">{signedName1}</h3>
          <div className="signature-wrapper">
            <div className="signature-canvas-container-sign">
              <SignatureCanvas
                ref={signaturePad1}
                penColor="black"
                backgroundColor="white"
                canvasProps={{ width: 400, height: 200, className: 'signature-canvas-sign w-full' }}
              />
              <div className="signature-buttons flex justify-center mt-4">
                <button
                  onClick={clearSignature1}
                  className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded text-sm">
                  Ulangi
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Signature Section 2 */}
        <div className="signature-section bg-gray-100 p-4 rounded shadow">
          <h3 className="text-lg font-semibold mb-4 text-center">{signedName2}</h3>
          <div className="signature-wrapper">
            <div className="signature-canvas-container-sign">
              <SignatureCanvas
                ref={signaturePad2}
                penColor="black"
                backgroundColor="white"
                canvasProps={{ width: 400, height: 200, className: 'signature-canvas-sign w-full' }}
              />
              <div className="signature-buttons flex justify-center mt-4">
                <button
                  onClick={clearSignature2}
                  className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded text-sm">
                  Ulangi
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flex justify-center mt-6">
        <button
          className="bg-yellow-500 hover:bg-yellow-600 text-white px-6 py-2 rounded text-sm font-semibold"
          onClick={saveSignature}>
          Diterima & Diserahkan
        </button>
      </div>
    </div>
  );
};

export default Signature;
